export default __webpack_public_path__ + "static/media/ethereum.b1488aa3.svg";